import { Injectable } from '@angular/core';
import { Region } from '@app/shared/models/region';
import { Territory } from '@app/shared/models/territory';
import { HttpClient } from '@angular/common/http'
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import * as moment from "moment";
import { DatePipe } from '@angular/common';

export interface Zone {
  code: string,
  associate_shape: number[][]
}

@Injectable()
export class ContractsService {

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe
  ) { }

  /**
   This function get the GPS coordinates of the Toulouse zones (P1, P2, P3, P4, and P5)
   */
  getContractZones(): Observable<Zone[]> {
    return this.http.get<Zone[]>(`${environment.API_URL}/workflows/zones/`)
  }

  getRegionsFromContracts(contracts): Region[] {
    let regions: Region[] = [];

    if (contracts) {
      contracts.forEach((contract) => {
        if (contract.n1_code && contract.n1_label && contract.n2_code && contract.n2_label) {
          let region: Region = {
            code: contract.n1_code,
            label: contract.n1_label,
            territories: []
          };

          let territory: Territory = {
            code: contract.n2_code,
            label: contract.n2_label,
          };

          let foundRegion = regions.find((r) => r.code === region.code);
          if (!foundRegion) {
            region.territories.push(territory);
            regions.push(region);
          } else if (!foundRegion.territories.some((t) => t.code === territory.code)) {
            foundRegion.territories.push(territory);
          }
        }
      });
    }

    // Sort territories
    regions.forEach((region) => {
      if (region.territories) {
        region.territories = region.territories.sort((a, b) => a.code.localeCompare(b.code));
      }
    });

    return regions.sort((a, b) => a.code.localeCompare(b.code));
  }

  filterContractsByRegionsAndTerritories(contracts, regions: string[], territories: string[]) {
    return contracts.filter((contract) => {
      if (regions.length === 0 && territories.length === 0) return true;

      let isOk = true;
      if (isOk && regions.length > 0) {
        isOk = regions.indexOf(contract.n1_code) != -1;
      }

      if (isOk && territories.length > 0) {
        isOk = territories.indexOf(contract.n2_code) != -1;
      }

      return isOk;
    });
  }

  isContractExpired(contract): boolean {
    return contract.date_fin_exploitation && contract.date_fin_exploitation < moment(new Date()).format('YYYY-MM-DD')
  }

  isContractNotSeen(contract): boolean {
    //only for national - disabled for other clients
    if(environment.client_name !== 'national') {
      return false;
    }

    let isNotSeen = false; 

    // check if contract not seen (last_seen_rcc) since 7 days 
    if (contract.last_seen_rcc) { 
      const lastSeenRcc = new Date(contract.last_seen_rcc);
      lastSeenRcc.setDate(lastSeenRcc.getDate() + 7);
      isNotSeen = new Date() > lastSeenRcc;
    }
    //return
    return isNotSeen;  
  }

  getContractTooltip(contract) {
    let tooltip = `${contract.code} - ${contract.label}`
    if (this.isContractExpired(contract)) tooltip += ` (échu le ${this.datePipe.transform(contract.date_fin_exploitation,'dd/MM/yyyy')})`
    if (this.isContractNotSeen(contract)) tooltip += ` (annulé le ${this.datePipe.transform(contract.last_seen_rcc,'dd/MM/yyyy')})`
    return tooltip
  }
}
